import * as apiFunction from '@services/apiFunctions'

import { clearsEmptyProperties } from '@utils/functions/clearsEmptyProperties'

import type {
  CreateNewOtherServiceRequestProps,
  CreateNewServiceRequestProps,
  DistributeBillingRequestProps,
  EditServiceRequestProps,
  GetLastDistributionValuesRequestProps,
  GetOtherServicesRequestProps,
  GetServiceDescriptionsRequestProps,
  GetServiceGroupingRequestProps,
  GetWeeklyBreakdownRequestProps,
  RemoveOtherServiceRequestProps,
  RemoveSelectedServicesRequestProps,
  RemoveServiceRequestProps,
  ResetClientRequestProps
} from './types'

import { API_URLS } from '@services/apiRoutes'

export const removeOtherService = async ({ serviceId, filiCode, clientCode }: RemoveOtherServiceRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${filiCode}/${clientCode}/outros-servicos/${serviceId}`,
    method: 'DELETE'
  })
}

export const editOtherService = async (payload: CreateNewOtherServiceRequestProps) => {
  const data = clearsEmptyProperties(payload)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${data.branchCode}/${data.clientId}/outros-servicos/${data.idOutrosServicos}`,
    method: 'PUT',
    body: data
  })
}

export const createNewOtherService = async (payload: CreateNewOtherServiceRequestProps) => {
  const data = clearsEmptyProperties(payload)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${data.branchCode}/${data.clientId}/outros-servicos`,
    method: 'POST',
    body: data
  })
}

export const getOtherServices = async (payload: GetOtherServicesRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${payload.filiCode}/${payload.clientCode}/busca-outros-servicos`,
    method: 'POST',
    body: {
      fatDtCompetencia: payload.competenceDate,
      currentPage: payload.currentPage,
      itemsPerPage: payload.itemsPerPage
    }
  })
}

export const removeService = async ({ serviceId, filiCode, clientCode }: RemoveServiceRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${filiCode}/${clientCode}/agrupamento-servico/${serviceId}`,
    method: 'DELETE'
  })
}

export const removeSelectedServices = async ({
  filiCode,
  clientCode,
  fatDtCompetencia,
  deleteAll,
  ids
}: RemoveSelectedServicesRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${filiCode}/${clientCode}/agrupamento-servico`,
    method: 'DELETE',
    body: deleteAll ? { deleteAll: true, fatDtCompetencia } : { deleteAll: false, ids, fatDtCompetencia }
  })
}

export const editService = async (payload: EditServiceRequestProps) => {
  const body = clearsEmptyProperties(payload)

  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${payload.filiCodigo}/${payload.cdClienteNl}/agrupamento-servico/${payload.serviceId}`,
    method: 'PUT',
    body
  })
}

export const createNewService = async (payload: CreateNewServiceRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${payload.filiCodigo}/${payload.cdClienteNl}/agrupamento-servico`,
    method: 'POST',
    body: payload
  })
}

export const getServiceDescriptions = async (payload: GetServiceDescriptionsRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.invoicing}/${payload.filiCodigo}/${payload.cdClienteNl}/descricao-servico`,
    method: 'GET',
    params: { nmAgrupamentoServico: payload.nmAgrupamentoServico, fatDtCompetencia: payload.fatDtCompetencia }
  })
}

export const getServiceGrouping = async (payload: GetServiceGroupingRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.invoicing}/${payload.filiCodigo}/${payload.cdClienteNl}/agrupamento-servico`,
    method: 'GET'
  })
}

export const resetClient = async (payload: ResetClientRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/resetar-valor-dias`,
    method: 'POST',
    body: payload
  })
}

export const distributeBilling = async (payload: DistributeBillingRequestProps) => {
  const body = clearsEmptyProperties(payload)

  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/atualizar-valor-dias`,
    method: 'POST',
    body
  })
}

export const getWeeklyBreakdown = async (payload: GetWeeklyBreakdownRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.invoicing}/${payload.filiCodigo}/${payload.cdClienteNl}`,
    method: 'POST',
    body: {
      fatDtCompetencia: payload.fatDtCompetencia,
      currentPage: payload.currentPage,
      itemsPerPage: payload.itemsPerPage
    }
  })
}

export const getLastDistributionValues = async (payload: GetLastDistributionValuesRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.invoicing}/${payload.filiCodigo}/${payload.cdClienteNl}/ultimo-percentual-distribuicao`,
    method: 'GET'
  })
}
